import { Dialog, DialogContent } from '@mui/material';
import { KYCSubmitted } from './KYCSubmitted';
import { KYXContext } from 'context/kyx-context';
import { KYXFirstStep } from './KYXFirstStep';
import { KYXSecondStep } from './KYXSecondStep';
import { KYXThirdStep } from './KYXThirdStep';
import { makeStyles } from '@mui/styles';
import { useContext } from 'react';
import { useForm } from 'Hooks/useForm';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const useStyles = makeStyles({
    banner: {
        backgroundColor: '#182D55 !important',
        maxWidth: '16em',
        minHeight: '100%',
        paddingTop: '3em'
    },
    dialogBody: {
        display: 'flex',
        flexDirection: 'row',
        minHeight: '600px',
        height: '100%'
    },
    bannerTitle: {
        color: 'white',
        fontWeight: '700!important'
    },
    bannerSpan: {
        color: 'white'
    },
    bannerText: {
        margin: '1em'
    },
    dialogContent: {
        backgroundColor: 'transparent!important',
        padding: '0!important'
    },
    content: {
        margin: '2em',
        width: '100%'
    },
    contentTitle: {
        fontWeight: '700!important'
    },
    verifyOption: {
        borderRadius: '5px',
        border: '1px solid #d4d4d4',
        padding: '1em',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    verifyText: {
        maxWidth: '30em'
    },
    verifyTitle: {
        fontWeight: '700!important'
    },
    startKYX: {
        color: 'white!important',
        borderRadius: '25px!important',
        marginLeft: '1em',
        padding: '.5em 3em!important'
    },
    doItLater: {
        marginTop: '10em'
    }
});

export const KYXmodal = ({ onOpenKYBModal }) => {
    const { setCurrentKYCStep, currentKYCStep, setIsKYXModalOpen, isKYXModalOpen } = useContext(KYXContext);
    const classes = useStyles();
    const [formValues, handleInputChange, setFormValues] = useForm({
        phoneNumber: '',
        dateOfBirth: '',
        jobTitle: '',
        ssn: '',
        line1: '',
        line2: '',
        city: '',
        state: '',
        postalCode: ''
    });
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const incrementPage = () => {
        setCurrentKYCStep(currentKYCStep + 1);
    };

    const decreasePage = () => {
        setCurrentKYCStep(currentKYCStep - 1);
    };

    const handleCloseDialog = () => {
        setIsKYXModalOpen(false);
    };

    return (
        <Dialog maxWidth="lg" id="dialogKYC" className={classes.dialog} open={isKYXModalOpen} fullScreen={fullScreen}>
            <DialogContent
                className={classes.dialogContent}
                sx={{
                    minWidth: { lg: '64em', md: '50em', sm: 'auto', xs: 'auto' }
                }}>
                {{
                    0: (
                        <KYXFirstStep
                            handleClose={handleCloseDialog}
                            incrementPage={incrementPage}
                            openModalKYB={onOpenKYBModal}
                        />
                    ),
                    1: (
                        <KYXSecondStep
                            handleInputChange={handleInputChange}
                            formValues={formValues}
                            setFormValues={setFormValues}
                            activePage={currentKYCStep}
                            handleClose={handleCloseDialog}
                            incrementPage={() => incrementPage()}
                        />
                    ),
                    2: (
                        <KYXThirdStep
                            handleInputChange={handleInputChange}
                            formValues={formValues}
                            activePage={currentKYCStep}
                            handleClose={handleCloseDialog}
                            incrementPage={() => incrementPage()}
                            decreasePage={() => decreasePage()}
                        />
                    ),
                    3: (
                        <KYCSubmitted
                            activePage={currentKYCStep}
                            handleClose={handleCloseDialog}
                            incrementPage={() => incrementPage()}
                            decreasePage={() => decreasePage()}
                            openModalKYB={onOpenKYBModal}
                        />
                    )
                }[currentKYCStep] || <div>error</div>}
            </DialogContent>
        </Dialog>
    );
};
